import React from 'react';
import { ModalCard } from 'components/cards/ModalCard';
import { Grid } from 'components/layout/Grid';
import scienceVillageSrc from 'assets/media/lkf/science-village.png';
import { Text } from 'components/typography/Text';
import { Brikk } from 'components/Brikk';
import { NextStep } from 'components/form-elements/buttons/NextStep';
import { useRedirect } from 'utils/redirect';
import { LKFOnboardingRoutes } from 'pages/onboarding/LKFOnboarding/routes';
import { OnboardingGrid } from 'pages/onboarding/OnboardingGrid';
import { ImageGalleryOverlay } from '../ImageGalleryOverlay';

export const ScienceVillage = () => {
  const { onRedirect } = useRedirect(LKFOnboardingRoutes.XPLORION);

  return (
    <ModalCard>
      <OnboardingGrid>
        <Grid.Column>
          <ImageGalleryOverlay
            imageSrc={scienceVillageSrc}
            overlayIntl="onboardingScienceVillageTitle"
          />
        </Grid.Column>

        <Grid.Column>
          <Brikk.Heading heading="onboardingScienceVillageHeading">
            <Text
              size={18}
              intl="onboardingScienceVillageDescription"
            />
          </Brikk.Heading>
        </Grid.Column>

        <NextStep onClick={() => onRedirect()} />
      </OnboardingGrid>
    </ModalCard>
  );
};
